
























import 'flatpickr/dist/flatpickr.css'
// docs https://flatpickr.js.org/examples/#flatpickr-external-elements
import flatpickrFn from "flatpickr";
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component'
import { Component, Prop, VModel } from 'vue-property-decorator'

import { DateRange, PickerDayFn, PickerFormat, PickerInputMode } from './types'

enum DateSeparator {
  Range = ' - ',
  Multiple = ', '
}

@Component({
  components: {
    flatPickr,
  },
})
export default class Picker extends Vue {
  @VModel() model!: string | Array<string> | null

  @Prop({ type: Boolean }) readonly disabled!: boolean

  @Prop({ type: String, default: PickerInputMode.Single }) readonly inputMode!: PickerInputMode

  @Prop({ type: String, default: PickerFormat.Date }) readonly format!: PickerFormat

  @Prop() readonly enabledDays!: Array<string> | Array<PickerDayFn> | Array<DateRange>

  @Prop() readonly disabledDays!: Array<string> | Array<PickerDayFn> | Array<DateRange>

  @Prop({ type: Boolean, default: true }) readonly time24hr!: boolean

  @Prop({ type: Boolean, default: true }) clearable!:boolean

  @Prop({ type: String, default: '', required: false }) placeholder!:string

  @Prop({ type: HTMLElement }) appendTo!: HTMLElement

  @Prop({ default: null }) minDate!: flatpickrFn.Options.Options['minDate']

  @Prop({ default: null }) maxDate!: flatpickrFn.Options.Options['maxDate']

  get modelValue(): string | Array<string> | null {
    return this.inputMode === PickerInputMode.Single ? this.model : (this.model as Array<string>).join(this.dateSeparator)
  }

  set modelValue(value: string | Array<string> | null) {
    if (this.inputMode === PickerInputMode.Single) {
      this.model = value
    } else {
      if (value === null) {
        this.model = []
      } else {
        if (typeof value === 'string') {
          this.model = value.split(this.dateSeparator)
        }

        if (Array.isArray(value)) {
          this.model = value
        }
      }
    }
    // this.model = this.inputMode === PickerInputMode.Single ? value : (value as string).split(this.dateSeparator)
  }

  // eslint-disable-next-line consistent-return,getter-return
  get locale(): any {
    if (this.$i18n.locale === 'ru') {
      return Russian
    }
    return {}
  }

  get dateSeparator(): DateSeparator | string {
    if (this.inputMode === PickerInputMode.Range) {
      return DateSeparator.Range
    }
    if (this.inputMode === PickerInputMode.Multiply) {
      return DateSeparator.Multiple
    }
    return ''
  }

  get config() {
    const DATE_FORMAT = 'Y-m-d'
    const DATE_ALT_FORMAT = 'M j, Y'
    const TIME_FORMAT = 'H:i:S'
    const TIME_ALT_FORMAT = 'H:i'

    const config: flatpickrFn.Options.Options = {
      wrap: true,
      altInput: true,
      time_24hr: this.time24hr,
      locale: Object.assign(this.locale, { rangeSeparator: ' - ' }),
      mode: this.inputMode,
      minDate: this.minDate,
      maxDate: this.maxDate
    }

    if (this.inputMode === PickerInputMode.Range) {
      config.conjunction = ' - '
    }

    if (this.format === PickerFormat.DateTime) {
      config.enableTime = true
      config.dateFormat = `${ DATE_FORMAT } ${ TIME_FORMAT }`
      config.altFormat = `${ DATE_ALT_FORMAT } ${ TIME_ALT_FORMAT }`
    }

    if (this.format === PickerFormat.Date) {
      config.dateFormat = DATE_FORMAT
      config.altFormat = DATE_ALT_FORMAT
    }

    if (this.format === PickerFormat.Time) {
      config.enableTime = true
      config.noCalendar = true
      config.dateFormat = TIME_FORMAT
      config.altFormat = TIME_ALT_FORMAT
    }

    if (this.appendTo) {
      config.appendTo = this.appendTo
    }

    return config
  }

  get isDisabledClearButton(): boolean {
    return this.disabled || !this.modelValue || !this.modelValue.length
  }

  clear(): void {
    if (this.inputMode === PickerInputMode.Single) {
      this.modelValue = null
    } else {
      this.modelValue = []
    }
  }
}
